
export const GroupEndpoints = (builder) => ({

  getGroups: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/group-list',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Group'],
  }),

  getGroupById: builder.query({
    query: (id) => ({
      url: `/common/get-GroupById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Group', id }],
  }),

  getCustomerByGroupId: builder.query({
    query: (groupId) => ({
      url: `/common/customers/by-group/${groupId}`,
      method: 'GET',
    }),
    providesTags: ['Group'],
  }),

  saveGroup: builder.mutation({
    query: (data) => ({
      url: '/common/save-Group',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Group'],
  }),

  updateGroup: builder.mutation({
    query: ({ data }) => ({
      url: `/common/save-Group`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'Group', id },
      'Group'
    ],
  }),

  deleteGroup: builder.mutation({
    query: (id) => ({
      url: `/common/delete-Group/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Group'],
  }),

});
